import { defineStore } from "pinia"
import { ref } from "vue"
import store from "../js/store"
import http from "../js/http"
import { modalController } from "@ionic/vue"

export const useClassEndCountdown = defineStore("classEndCountdown", () => {
  const countdown = ref()
  const timer = ref()
  const count = ref(0)
  const isReminded = ref(false) // 是否提醒过

  function setCountdown() {
    const appointment = store.getAppointment()
    if (appointment != null) {
      http.get("/record/readRemainingTime?aptmId=" + appointment.aptmId).then((res) => {
        if (res?.data.success) {
          console.log("同步了剩余时间：" + res.data.time)
          countdown.value = res.data.time
        } else {
          location.replace("/TeacherIndex")
        }
      })
    } else {
      isReminded.value = true
      countdown.value = undefined
      clearInterval(timer.value)
    }
  }

  function countdownTimeInterval(that: any, aptmId: string | number) {
    timer.value = setInterval(async () => {
      if (count.value % 60 === 0) {
        setCountdown()
      }
      count.value++
      if (countdown.value <= 0) {
        isReminded.value = true
        countdown.value = undefined
        clearInterval(timer.value)
        endClass(aptmId)
      } else if (countdown.value <= 300 && !isReminded.value) {
        isReminded.value = true
        that.audio(that.voice_path + "clock.mp3")
        that.alert("本次训练倒计时5分钟，请尽快完成并提交结果！")
      }

      if (countdown.value) {
        countdown.value--
      }
    }, 1000)
  }

  function resetClassCountdown() {
    clearInterval(timer.value)
    countdown.value = undefined
    count.value = 0
  }

  function endClass(aptmId: any) {
    http
      .post(`/record/endClass?aptmId=${aptmId}&flag=1`, {}, "", "", "", 3000, true)
      .then(async (res) => {
        if (res.data.success) {
          modalController
            .dismiss()
            .then()
            .catch((e) => console.log(e))
          localStorage.removeItem("GenerateContent")
          localStorage.removeItem("GLOSSARY_ARRAY")
          localStorage.removeItem("endCountdown")
          location.replace("/TeacherIndex")
        } else {
          modalController
            .dismiss()
            .then()
            .catch((e) => console.log(e))
          localStorage.removeItem("GenerateContent")
          localStorage.removeItem("GLOSSARY_ARRAY")
          localStorage.removeItem("endCountdown")
          location.replace("/TeacherIndex")
        }
      })
  }

  return {
    countdown,
    countdownTimeInterval,
    resetClassCountdown,
  }
})
